import { render } from "./TradeCallDialog.vue?vue&type=template&id=5373de42"
import script from "./TradeCallDialog.vue?vue&type=script&lang=js"
export * from "./TradeCallDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__